//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Box, Button, Typography } from '@mui/material'
import React, { ReactElement } from 'react'

import { OtDispatch, useOtDispatch, useOtSelector } from '@react/redux/store'

import { ERC20Wei } from '@shared/conversions'
import { EthAddr } from '@shared/SchemaTypes'
import { PoolOverviewCTO, PoolOverviewCTOSchema } from '@shared/sharedTypes'
import { ETH_ADDR_ZERO } from '@shared/SchemaTypes'
import ViewField from '@react/components/elements/ViewField'
import { theme } from '@react/components/theme'
import { withdrawFeesTx } from '@react/signedTxs/withdrawFeesTx'

export default function AdminFeeWithdrawalForm(props: { poolAddr: EthAddr }): ReactElement {
  const { poolAddr } = props
  const dispatch: OtDispatch = useOtDispatch()

  const poolOverviewCTO = useOtSelector(
    (state) => state.poolState.poolOverviewCTOs[poolAddr ?? ETH_ADDR_ZERO] as PoolOverviewCTO
  )
  const [isSubmitted, setIsSubmitted] = React.useState(false)
  const sx = {
    backgroundColor: theme.palette.fg.main,
    color: '#FFFFFF',
    padding: '11px 16px 11px 16px',
    borderRadius: '6px',
    marginTop: '8px',
  }

  const handleWithdraw = (): void => {
    setIsSubmitted(true)

    dispatch(
      withdrawFeesTx({
        poolAddr: poolOverviewCTO.poolAddr,
        assets: poolOverviewCTO.feeVaultBalance as ERC20Wei,
      })
    )

    const event = new Event('modalClose')
    window.dispatchEvent(event)
  }

  return (
    <div data-testid="admin-wthdrawal-form" style={{ paddingTop: 20 }}>
      <Box sx={{ marginBottom: 4 }}>
        <ViewField dataObject={poolOverviewCTO} fieldSchema={PoolOverviewCTOSchema.describe().fields.feeVaultBalance} />
      </Box>

      <Button
        disabled={isSubmitted}
        sx={sx}
        onClick={() => {
          handleWithdraw()
        }}
        variant={'contained'}
      >
        <Typography variant={'buttonBold'}>Withdraw Fees</Typography>
      </Button>
    </div>
  )
}
